import type { RootState } from "../store"

export const selectedPracticeConfigurationSelector = (state: RootState) =>
    state.userDetails.selectedPracticeConfiguration
